import { useMemo } from 'react';

/**
 * While this function is intended to be ran in the browser, this function is called on the server-side as well as
 * in the testing environment where a window, or the matchMedia functions may not be available.
 * For this reason, we are being very explicit with the existence of these objects and functions
 * to prevent reference errors.
 * @returns boolean true if the user prefers reduced motion
 */
export const usePrefersReducedMotion = () => {
  return useMemo(() => {
    return (
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches === true
    );
  }, []);
};
